import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'user-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.css']
})
export class NotAuthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/errors/not-authorized/not-authorized.component.ts